import script from "./StatusComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./StatusComponent.vue?vue&type=script&lang=ts&setup=true"

import "./StatusComponent.vue?vue&type=style&index=0&id=3507cef1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3507cef1"]])

export default __exports__